import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { IDistricCoordinatorTraining } from '../../../shared/models/schedule';
import { Icons } from '../../../shared/helpers/icons';
import { IUserInfo } from '../../../shared/models/contact';
import { UserDataService } from '../../../shared/services/userData.service';
import { DateUtils } from '../../../shared/helpers/dateUtils';
import { LucideAngularModule } from 'lucide-angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
declare var initFlowbite: any;

@Component({
  selector: 'training-table',
  standalone: true,
  imports: [    
    LucideAngularModule,
    CommonModule,
    FormsModule,
    NgxPaginationModule
  ],
  templateUrl: './training-table.component.html',
  styleUrl: './training-table.component.css'
})
export class TrainingTableComponent implements OnInit, OnChanges, OnDestroy {

  @Input() schedulesList: IDistricCoordinatorTraining[] = [];
  @Output() onOpenModal = new EventEmitter<{ modalName: string, selectedItem?: IDistricCoordinatorTraining }>();
  @Output() onSchoolYearChange = new EventEmitter<string>();

  icons = Icons;

  searchQuery: string = '';
  filteredSchedulesList: IDistricCoordinatorTraining[] = [];
  currentSchedule: IDistricCoordinatorTraining | null = null;
  buildingId: string | null = null;
  currentUser: IUserInfo | null = null;
  messageModal: string | null = null;
  popupMessage: string | null = null;
  message: string | null = null;
  page = 1;
  itemsPerPage = 10;
  schoolYears: string[] = [];
  selectedSchoolYear: string = '';

  loading: boolean = false;
  sortOrder: boolean = true;
  showHistory: boolean = false;
  isSchoolYearDropdownOpen = false;

  constructor(
    private userDataService: UserDataService,
  ) {}

  ngOnInit(): void {
    initFlowbite()
    this.currentUser = this.userDataService.getUserData();
    document.addEventListener('click', this.handleClickOutside);
    this.schoolYears = DateUtils.getSchoolYears(6);
    this.selectedSchoolYear = DateUtils.getCurrentSchoolYear();
  }
  
  ngOnDestroy(): void {
    document.removeEventListener('click', this.handleClickOutside);
  }
  
  handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest('#schoolYearDropdownButton') && !target.closest('#schoolYearDropdown')) {
      this.isSchoolYearDropdownOpen = false;
    }
  };  

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['schedulesList']) {
      this.filteredSchedulesList = [...this.schedulesList];
    }
  }

  sortList(key: keyof typeof this.filteredSchedulesList[0]): void {
    this.sortOrder = !this.sortOrder;
    this.filteredSchedulesList.sort((a, b) => {
      const valueA = a[key]?.toString().toLowerCase() || '';
      const valueB = b[key]?.toString().toLowerCase() || '';

      if (valueA < valueB) {
        return this.sortOrder ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortOrder ? 1 : -1;
      }
      return 0;
    });
  }
  
  toggleSchoolYearDropdown(): void {
    this.isSchoolYearDropdownOpen = !this.isSchoolYearDropdownOpen;
  }

  handleSchoolYearSelect(year: string): void {
    this.selectedSchoolYear = year;
    this.isSchoolYearDropdownOpen = false;
    this.onSchoolYearChange.emit(year);
  }

  filterSchedulesList(): void {
    this.filteredSchedulesList = this.schedulesList.filter((item) => {
      return (
        item.name?.toLowerCase()
          .includes(this.searchQuery.toLowerCase()) ||
        item.last_updated_user_name?.toLowerCase()
          .includes(this.searchQuery.toLowerCase()) ||
        item.last_updated_at?.toLowerCase()
          .includes(this.searchQuery.toLowerCase()) ||
        item.duration?.toString().toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );
    });
  }

  handleBtnClick(modalName: string, selectedItem?: IDistricCoordinatorTraining): void {
    console.log("Button clicked for modal:", modalName, selectedItem);
    this.onOpenModal.emit({ modalName, selectedItem });
  }
  
  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = null;
  }
  
  canSave(): boolean {
    if (!this.currentUser) return false;
    return this.currentUser.can_edit || this.currentUser.can_admin;
  }

}
